module.exports = __webpack_public_path__ + "media/badges/mystery-circle-6f5658be.png";